<template>
  <vue-calendly :height="height" :url="url" />
</template>

<script>
import { onBeforeUnmount, onMounted } from '@nuxtjs/composition-api';

export default {
  props: {
    height: {
      type: Number,
      default: 550,
    },
    url: {
      type: String,
      required: true,
    },
  },
  setup(_, { emit }) {
    const onCalendlyMessage = (e) => {
      if (e?.data?.event === 'calendly.event_scheduled') {
        emit('event-scheduled', e.data);
      }
    };

    onMounted(() => {
      window.addEventListener('message', onCalendlyMessage);
    });

    onBeforeUnmount(() => {
      window.removeEventListener('message', onCalendlyMessage);
    });
  },
};
</script>
